import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { RegisterComponent } from './register/register.component';
// import { LoginGuard } from './guards/login.guard';
import { ChatpageComponent } from './chatpage/chatpage.component';
import { ContactComponent } from './contact/contact.component';
import { MessageComponent } from './message/message.component';
import { OnlineUserComponent } from './online-user/online-user.component';
import { ChatguardGuard } from './guards/chatguard.guard';

const routes: Routes = [
  {path:'', redirectTo:"/home", pathMatch:"full"},
   {path:"home", component:HomeComponent},
  {path:"login", component:LoginComponent},
  {path:"register", component:RegisterComponent},
  {path:"chatpage", component:ChatpageComponent,canActivate:[ChatguardGuard]},
  {path:"contact", component:ContactComponent},
  {path:"message", component:MessageComponent},
  {path:"online-user", component:OnlineUserComponent},
  {path:"message", component:MessageComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
